export default "__VITE_ASSET__d1d1c11c__"